import React, { useState } from 'react';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { POPULAR_ICONS } from '../lib/icons';

const { FiX, FiGlobe } = FiIcons;

export default function IconPicker({ selectedIcon, onSelect, onClose }) {
  const [search, setSearch] = useState('');

  const filteredIcons = POPULAR_ICONS.filter(icon =>
    icon.name.toLowerCase().includes(search.toLowerCase())
  );

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-2xl shadow-2xl max-w-lg w-full max-h-[80vh] overflow-hidden flex flex-col">
        <div className="p-4 border-b border-gray-100 flex items-center justify-between">
          <h3 className="font-bold text-lg text-gray-900">Choose an Icon</h3>
          <button
            onClick={onClose}
            className="p-2 hover:bg-gray-100 rounded-lg transition-colors"
          >
            <SafeIcon icon={FiX} size={20} className="text-gray-500" />
          </button>
        </div>

        <div className="p-4 border-b border-gray-100 space-y-4">
          <button
            onClick={() => onSelect('favicon')}
            className={`w-full py-3 px-4 rounded-xl border-2 flex items-center justify-center gap-2 transition-all ${
              selectedIcon === 'favicon'
                ? 'border-blue-500 bg-blue-50 text-blue-700'
                : 'border-gray-200 hover:border-gray-300 text-gray-700'
            }`}
          >
            <SafeIcon icon={FiGlobe} size={20} />
            <span className="font-semibold">Use Website Favicon</span>
          </button>

          <input
            type="text"
            value={search}
            onChange={(e) => setSearch(e.target.value)}
            placeholder="Search icons..."
            className="w-full px-4 py-2 bg-gray-50 border border-gray-200 rounded-xl outline-none focus:ring-2 focus:ring-blue-500"
          />
        </div>

        <div className="flex-1 overflow-y-auto p-4">
          <div className="grid grid-cols-5 gap-3">
            {filteredIcons.map((iconData) => {
              const Icon = iconData.icon;
              const isSelected = selectedIcon === iconData.name;
              return (
                <button
                  key={iconData.name}
                  onClick={() => onSelect(iconData.name)}
                  className={`p-4 rounded-xl border-2 transition-all hover:scale-105 ${
                    isSelected
                      ? 'border-blue-500 bg-blue-50'
                      : 'border-gray-200 hover:border-gray-300'
                  }`}
                  title={iconData.name}
                >
                  <SafeIcon
                    icon={Icon}
                    size={24}
                    className={isSelected ? 'text-blue-600' : 'text-gray-600'}
                  />
                </button>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}
export { POPULAR_ICONS };